import React, { useEffect } from "react";
import { Form, Input, InputNumber, Button, Typography, Row, Col, Space, message, Card } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import api from "../../API";

function Package() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const defaultInfo = location.state;

  useEffect(() => {
    if(defaultInfo){
        form.setFieldsValue({
            packageCode: defaultInfo.packageCode,
            packageName: defaultInfo.packageName,
            packageDesc: defaultInfo.packageDesc,
            consultingUnitPrice: defaultInfo.consultingUnitPrice,
            transactionUnitPrice: defaultInfo.transactionUnitPrice,
            promotionUnitPrice: defaultInfo.promotionUnitPrice,
            packagePrice: defaultInfo.packagePrice,
            totalMessage: defaultInfo.totalMessage
        })
    }
  }, []);

  const handleSubmit = async (values) => {
    try {
        const response = defaultInfo ? 
            await api.update_packageById(defaultInfo.id, values) :
            await api.create_new_package(values);
        message.success(response.message);
        navigate('/packages');
    } catch (error) {
        message.error(error.message)
    }
  };

  const priceFormat = {
    min: 0,
    formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    parser: (value) => value.replace(/\$\s?|(,*)/g, ''),
    style: { width: "100%" }
  };

  return (
    <Card 
        style={{ maxWidth: 800, margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title= {
        <Space align="center">
            <Link to="/packages">
                <Button style={{width: 50}} icon={<ArrowLeftOutlined />} />
            </Link>
            <Typography.Title level={5} style={{margin: 0}}>
                {defaultInfo ? "Update" : "Create New"} Package
            </Typography.Title>
        </Space>
    }>
        <Form 
            form={form} 
            layout="vertical" 
            onFinish={handleSubmit}
            initialValues={{ isActive: 1 }}
        >
            <Row gutter={[16, 0]}>
                <Col span={24}>
                    <Form.Item label="Package Code" name="packageCode" rules={[{ required: true, message: "Package Code cannot be empty" }]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Package Name" name="packageName" rules={[{ required: true, message: "Package Name cannot be empty" }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label="Package Description" name="packageDesc">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="Consulting Unit Price" name="consultingUnitPrice" rules={[{ required: true, message: "Consulting Unit Price cannot be empty" }]}>
                        <InputNumber {...priceFormat} />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="Transaction Unit Price" name="transactionUnitPrice" rules={[{ required: true, message: "Transaction Unit Price cannot be empty" }]}>
                        <InputNumber {...priceFormat} />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="Promotion Unit Price" name="promotionUnitPrice" rules={[{ required: true, message: "Promotion Unit Price cannot be empty" }]}>
                        <InputNumber {...priceFormat} />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                    <Form.Item label="Package Price" name="packagePrice" rules={[{ required: true, message: "Package Price cannot be empty" }]}>
                        <InputNumber {...priceFormat} />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label="Total Message" name="totalMessage" rules={[{ required: true, message: "Total Message cannot be empty" }]}>
                        <InputNumber min={1} style={{ width: "100%" }}/>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item style={{ textAlign: "center" }}>
                <Button type="primary" htmlType="submit" icon={defaultInfo? <EditOutlined/>: <SaveOutlined/>}>
                    {defaultInfo? "Update": "Save"}
                </Button>
            </Form.Item>
        </Form>
    </Card>
  );
};

export default Package;
